import { render, staticRenderFns } from "./SystemAlerts.vue?vue&type=template&id=37e296b0&scoped=true"
import script from "./SystemAlerts.vue?vue&type=script&lang=js"
export * from "./SystemAlerts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37e296b0",
  null
  
)

export default component.exports